import { Component, NgModule, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from '../../services/auth/auth.service';
import { ImpersonationService } from '../../services/impersonation.service';

import { UserPanelModule } from '../user-panel/user-panel.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';

import { Router } from '@angular/router';
import { IApiUserAuthenticated } from '../../interfaces/IApiUserAuthenticated';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  user: IApiUserAuthenticated | null = {LifeTime: new Date('1970/01/01'), Id : 0, JwtToken: "", Email: "", FirstName: "",LastName:"", Role: "",RefreshToken:"",Created:new Date('1970/01/01'),IsVerified:false, IdPjf: 0,idListaPrecio:1,ListaExcluidos:true, pjf: null};

  userMenuItems = [
  {
    text: 'Logout',
    icon: 'runner',
    onClick: () => {
      this.authService.logout();
    }
  },
  {
    text: 'Modificar Datos',
    icon: 'card',
    onClick: () => {
      this.router.navigate(['/', 'update-account', this.user?.IdPjf]);
      // .then(nav => {
      //   console.log(nav)
      // }, err => {
      //   console.log("Error en navegacion", err)
      // });
    }
  },
  {
    text: 'Limpiar Sesión',
    icon: 'refresh',
    onClick: () => {
      this.clearCorruptedSession();
    }
  }
];

  constructor(
    private authService: AuthService, 
    private router: Router,
    private impersonationService: ImpersonationService
  ) { }

  get isUser(): boolean {
    return this.user?.Role === 'User';
  }

  ngOnInit() {
    this.user = this.authService.getUser;
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  }

  /**
   * Función de emergencia para limpiar sesiones corruptas
   */
  clearCorruptedSession(): void {
    console.log('🆘 Función de emergencia: Limpiando sesión corrupta desde header');
    
    try {
      // Si está impersonalizado, intentar restaurar usuario original primero
      if (this.impersonationService.isImpersonating()) {
        console.log('🔄 Detectada impersonalización - intentando restauración de emergencia');
        
        const success = this.impersonationService.forceRestoreOriginalUser();
        
        if (success && this.authService.getUser) {
          notify({
            type: "success",
            message: "✅ Sesión de impersonalización restaurada exitosamente",
            displayTime: 3000
          });
          
          // Recargar la página para refrescar el estado
          window.location.reload();
          return;
        }
      }
      
      // Si no está impersonalizado o la restauración falló, limpiar todo
      console.log('🧹 Limpieza completa de sesión de emergencia');
      
      this.authService.clearCorruptedSession('Limpieza manual desde menú de usuario');
      
      notify({
        type: "warning",
        message: "🔄 Sesión limpiada. Redirigiendo al login...",
        displayTime: 2000
      });
      
      // Redirigir al login después de un breve delay
      setTimeout(() => {
        this.router.navigate(['/login-form']);
      }, 1000);
      
    } catch (error) {
      console.error('❌ Error en limpieza de emergencia:', error);
      
      notify({
        type: "error",
        message: "❌ Error al limpiar sesión. Recarga la página manualmente.",
        displayTime: 4000
      });
      
      // Como último recurso, recargar la página
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule
  ],
  declarations: [ HeaderComponent ],
  exports: [ HeaderComponent ]
})
export class HeaderModule { }